import { CampaignExperience, MonetateExperience } from './index.d'
import { hasKey } from './utils'

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    jlData: {
      monetateServer: {
        campaigns: CampaignExperience[]
      }
    }
  }
}

export const writeCampaigns = (experiences: Array<MonetateExperience>) => {
  const campaigns = getCampaigns(experiences)

  if (!campaigns?.length) {
    return
  }

  window.jlData = window.jlData || {}
  window.jlData.monetateServer = window.jlData.monetateServer || {}
  const monetateCampaigns = window.jlData.monetateServer.campaigns || []
  const allCampaigns = monetateCampaigns.concat(campaigns)

  window.jlData = {
    ...window.jlData,
    monetateServer: {
      ...window.jlData.monetateServer,
      campaigns: allCampaigns,
    },
  }
}

const getCampaigns = (
  experiences: Array<MonetateExperience>,
): CampaignExperience[] => {
  if (!experiences) {
    return []
  }

  return experiences.map(experience => {
    const key = hasKey(experience) ? experience.key : experience.experienceName;
    return {
      key,
      reports: [],
      split: experience.variantLabel,
      parameters: experience.parameters,
    }
  })
}
